export const getPrizeData = async (prizeId: string) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/surface/PrizeTicketSurface/GetPriceTicketFromContentNodeId?contentNodeId=${prizeId}`,
    {
      credentials: "include",
    }
  );
